import React from "react";
import ButtonBase from "./ButtonBase.jsx";
import { toast } from "react-toastify";

const MaxFileSize = 10 * 1024 * 1024;

export default function InputFile(props) {
    const refInput = React.useRef(null);

    // const {
    //     className,
    //     filename,
    //     name,
    //     onFileSelect,
    //     placeholder,
    //     read,
    //     style,
    // } = props;

    React.useEffect(() => {
        if (!refInput) {
            return null;
        }

        if (!props.filename) {
            refInput.current.value = "";
        }
    }, [props.filename]);

    function onFileSelect(event) {
        const file = event.target.files[0];

        if (file && file.size > MaxFileSize) {
            console.warn(`MaxFileSize: ${MaxFileSize}`, file);
            toast.error("Maximum file size - 10mb");
            return;
        }

        if (props.read) {
            const FR = new FileReader();

            FR.addEventListener("load", event => {
                props.onFileSelect({
                    name: file.name,
                    type: file.type,
                    dataUrlBase64: event.target.result,
                });
            });

            FR.readAsDataURL(file);
        } else {
            props.onFileSelect({
                name: file.name,
                type: file.type,
            });
        }
    }

    const CLInputFile = ["input-file-button"];
    props.className && CLInputFile.push(props.className);

    const InputProps = {
        ref: refInput,
        onChange: event => onFileSelect(event, "mobile"),
        type: "file",
        style: { display: "none" },
    };

    const ButtonProps = {
        className: CLInputFile.join(" "),
        style: props.style,
    };

    props.name !== undefined && (InputProps["name"] = props.name);
    // props.multiple !== undefined && (InputProps["multiple"] = true);

    return (
        <div>
            <input {...InputProps} />

            <ButtonBase {...ButtonProps} onClick={() => refInput.current.click()}>
                {!props.filename && props.placeholder}
                {props.filename}
            </ButtonBase>
        </div>
    );
}
